import React from 'react';
import { PropTypes } from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactTooltip from 'react-tooltip';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const randomIntFromInterval = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);

const TooltipInfo = ({ color = '#000', text, tooltipClasses }) => {
    const id = `tooltip-${randomIntFromInterval(1, 1000)}`;
    return (
        <>
            <a data-tip data-for={id} data-border data-border-color="gray">
                <FontAwesomeIcon icon={faInfoCircle} color={color} size="lg" className="cursor-pointer" />
            </a>
            <ReactTooltip className={tooltipClasses} id={id} type="light" effect="solid">
                <span dangerouslySetInnerHTML={{ __html: text }} />
            </ReactTooltip>
        </>
    );
};

TooltipInfo.propTypes = {
    color: PropTypes.string,
    text: PropTypes.string,
    tooltipClasses: PropTypes.string,
};

export default TooltipInfo;
